import(/* webpackMode: "eager" */ "/app/src/app/(landing-page)/(static-pages)/viewer-earnings/page.tsx")